// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__WG1C1","heading":"Dashboard_heading__TkYd2","createBtn":"Dashboard_createBtn__cEbje"};